var React = require('react');

function Wishlist16 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.9,8.4l-5.4,5.4c-0.3,0.3-0.7,0.3-1,0L2.1,8.4c-1.5-1.5-1.5-3.8,0-5.3C2.8,2.4,3.8,2,4.8,2s1.9,0.4,2.6,1.1L8,3.7\r\n\tl0.6-0.6C9.3,2.4,10.3,2,11.3,2c1,0,1.9,0.4,2.6,1.1C15.4,4.6,15.4,6.9,13.9,8.4z"}));
}

Wishlist16.defaultProps = {"width":"16","height":"16"};

module.exports = Wishlist16;

Wishlist16.default = Wishlist16;
